import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import '../../styles/common/NumberPicker.css';

const NumberPicker = ({ 
  value = 1, 
  onChange, 
  min = 1, 
  max = 20, 
  disabled = false,
  size = 'medium' // 'small', 'medium', 'large'
}) => {
  const handleIncrement = () => {
    if (value < max && !disabled) {
      onChange(value + 1);
    }
  };

  const handleDecrement = () => {
    if (value > min && !disabled) {
      onChange(value - 1);
    }
  };

  const handleInputChange = (e) => {
    if (disabled) return;
    
    const inputValue = parseInt(e.target.value, 10);
    if (!isNaN(inputValue) && inputValue >= min && inputValue <= max) {
      onChange(inputValue);
    }
  };

  const handleInputBlur = (e) => {
    if (disabled) return;
    
    let inputValue = parseInt(e.target.value, 10);
    
    // If invalid input, reset to current value
    if (isNaN(inputValue)) {
      e.target.value = value;
      return;
    }
    
    // Clamp to min/max bounds
    if (inputValue < min) {
      inputValue = min;
    } else if (inputValue > max) {
      inputValue = max;
    }
    
    onChange(inputValue);
    e.target.value = inputValue;
  };

  return (
    <div className={`number-picker ${size} ${disabled ? 'disabled' : ''}`}>
      <button
        type="button"
        className="number-picker-btn decrement"
        onClick={handleDecrement}
        disabled={disabled || value <= min}
        aria-label="Decrease number of attendees"
      >
        <FontAwesomeIcon icon={faMinus} />
      </button>
      
      <input
        type="number"
        className="number-picker-input"
        value={value}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        min={min}
        max={max}
        disabled={disabled}
        aria-label="Number of attendees"
      />
      
      <button
        type="button"
        className="number-picker-btn increment"
        onClick={handleIncrement}
        disabled={disabled || value >= max}
        aria-label="Increase number of attendees"
      >
        <FontAwesomeIcon icon={faPlus} />
      </button>
    </div>
  );
};

export default NumberPicker;